import { unstable__Button as Button } from "@hagerty/react-components";
import { Error } from "@hagerty/self-service-components";

import { routes } from "../../../../routing/routes";

import styles from "./ContactInfoError.module.scss";

export function ContactInfoError() {
  return (
    <div className={styles.errorContainer}>
      <Error>
        <Button as="a" variant="solid" href={routes.settings()}>
          Refresh page
        </Button>
      </Error>
    </div>
  );
}
